import { appInfo } from '../config/appinfo'

const fetchAPI = async (url: string, options = {}) => {
  const response = await fetch(url, options)
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.statusText}`)
  }
  return response.json()
}

export const coursesAPI = {
  getCourse: (courseId: string) =>
    fetchAPI(`${appInfo.apiDomain}/courses/${courseId}`),
  
  getAllCourses: () =>
    fetchAPI(`${appInfo.apiDomain}/courses/`),
  
  getCourseModules: (courseId: string) =>
    fetchAPI(`${appInfo.apiDomain}/api/labs/courses/${courseId}/labmodules`, {
      credentials: 'include'
  }),
}